import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "app-ctrl-segment-dynamic",
  templateUrl: "./ctrl-segment-dynamic.component.html",
  styleUrls: ["./ctrl-segment-dynamic.component.css"],
})
export class CtrlSegmentDynamicComponent implements OnChanges {
  @Input() survey: any;
  @Input() item: any;
  @Output() itemChanged = new EventEmitter();

  constructor() {}

  ngOnChanges(): void {}

  public onChangeDynamic() {
    this.itemChanged.emit({ item: this.item });
  }
}
